export class User {
    id?:number;
    user_name? : string;
    password? : string; 
    user_type? :string; 
    active_indicator?:number;
    security_question?:string; 
    security_answer?:string; 
    i_agree_pp? :boolean; 
    i_agree_tc? :Boolean; 
    phoneNumber?:number;
    activePlan?:string;
    token? :string; 
    email? : string; // user_name
}
